// extracted by mini-css-extract-plugin
export var growableInput = "_a2-0";
export var tagContainer = "_a2-2";
export var textInput = "_a2-1";